module.exports = __webpack_public_path__ + "static/img/6_IMG_20160307_160730.f5c9422b.jpg";